module.exports = __webpack_public_path__ + "img/icon-light-off.68276b6f.svg";